const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const BinNumberManagementQuery = {
    GetCreditCardTypes: `${Backofficebff}/v1/binmanagement/getcreditcardtypes`,
    GetBinInstallments: `${Backofficebff}/v1/binmanagement/getbininstallments`,
    GetBanks: `${Backofficebff}/v1/binmanagement/getbanks`,
    GetBlackListCreditCards: `${Backofficebff}/v1/binmanagement/getblacklistedcreditcards`,
    GetCreditCardTypeBinNumbers: `${Backofficebff}/v1/binmanagement/getcreditcardtypebinnumbers`,
};

export const BinNumberManagementCommand = {
    CreateCreditCardTypeBinNumbers: `${Backofficebff}/v1/binmanagement/createcreditcardtypebinnumbers`,
    CreateCreditCardTypeBinNumbersBulk: `${Backofficebff}/v1/binmanagement/createcreditcardtypebinnumberbulk`,
    CreateBlackListedCreditCards: `${Backofficebff}/v1/binmanagement/createblacklistedcreditcards`,
    CreateBlackListedCreditCardsBulk: `${Backofficebff}/v1/binmanagement/createblacklistedcreditcardbulk`,
    DeleteCreditCardTypeBinNumbers: `${Backofficebff}/v1/binmanagement/deletecreditcardtypebinnumbers/{id}`,
    DeleteBlackListedCreditCards: `${Backofficebff}/v1/binmanagement/deleteblacklistedcreditcards/{id}`,
};
